import { toggleNav } from '../../js/main'
import '../../css/reset.css'
import '../../css/constants.css'
import '../../css/main.css'
import '../../css/inhouse-product-common.css'
import '../page-jet-mixer/jet-mixer-data-grid.css'
import './jet-mixer.css'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

import './jet-mixer-three-animation-setup'


gsap.registerPlugin(ScrollTrigger)
gsap.set(document.querySelector('body'), {
    visibility: 'visible'
})
window.addEventListener('load', () => {
    // console.log('load')
    ScrollTrigger.refresh()
})

const cells = document.querySelectorAll('.cell')
cells.forEach((cell) => {
    cell.addEventListener('mouseover', (e) => {
        // console.log(e.target.classList[0] || e.target.parentNode.classList[0])
        const targetClassName = e.target.classList[0] || e.target.parentNode.classList[0];
        const arrayValues = targetClassName.split('-')
        const jHeaderValue = "" +arrayValues[0] + "-" + arrayValues[1];
        const pHeaderValue = `pdiff-`+arrayValues[2]

        document.querySelector("."+jHeaderValue).style.backgroundColor = "#327C8C"
        document.querySelector("."+pHeaderValue).style.backgroundColor = "#327C8C"
    } )
    cell.addEventListener('mouseleave', (e) => {
        // console.log(e.target.classList[0] || e.target.parentNode.classList[0])
        const targetClassName = e.target.classList[0] || e.target.parentNode.classList[0];
        const arrayValues = targetClassName.split('-')
        const jHeaderValue = "" +arrayValues[0] + "-" + arrayValues[1];
        const pHeaderValue = `pdiff-`+arrayValues[2]

        document.querySelector("."+jHeaderValue).style.backgroundColor = "#294DA9"
        document.querySelector("."+pHeaderValue).style.backgroundColor = "#D84242"
    })
})
toggleNav()
// entry()
console.log('this is jet mixing');